/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { CdkCell, CdkCellDef, CdkColumnDef, CdkHeaderCell, CdkHeaderCellDef, } from '@angular/cdk/table';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MatCellDef = CdkCellDef;
export const /** @type {?} */ _MatHeaderCellDef = CdkHeaderCellDef;
export const /** @type {?} */ _MatColumnDef = CdkColumnDef;
export const /** @type {?} */ _MatHeaderCell = CdkHeaderCell;
export const /** @type {?} */ _MatCell = CdkCell;
/**
 * Cell definition for the mat-table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
export class MatCellDef extends _MatCellDef {
}
MatCellDef.decorators = [
    { type: Directive, args: [{
                selector: '[matCellDef]',
                providers: [{ provide: CdkCellDef, useExisting: MatCellDef }]
            },] },
];
/**
 * @nocollapse
 */
MatCellDef.ctorParameters = () => [];
function MatCellDef_tsickle_Closure_declarations() {
    /** @type {?} */
    MatCellDef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatCellDef.ctorParameters;
}
/**
 * Header cell definition for the mat-table.
 * Captures the template of a column's header cell and as well as cell-specific properties.
 */
export class MatHeaderCellDef extends _MatHeaderCellDef {
}
MatHeaderCellDef.decorators = [
    { type: Directive, args: [{
                selector: '[matHeaderCellDef]',
                providers: [{ provide: CdkHeaderCellDef, useExisting: MatHeaderCellDef }]
            },] },
];
/**
 * @nocollapse
 */
MatHeaderCellDef.ctorParameters = () => [];
function MatHeaderCellDef_tsickle_Closure_declarations() {
    /** @type {?} */
    MatHeaderCellDef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatHeaderCellDef.ctorParameters;
}
/**
 * Column definition for the mat-table.
 * Defines a set of cells available for a table column.
 */
export class MatColumnDef extends _MatColumnDef {
}
MatColumnDef.decorators = [
    { type: Directive, args: [{
                selector: '[matColumnDef]',
                providers: [{ provide: CdkColumnDef, useExisting: MatColumnDef }],
            },] },
];
/**
 * @nocollapse
 */
MatColumnDef.ctorParameters = () => [];
MatColumnDef.propDecorators = {
    'name': [{ type: Input, args: ['matColumnDef',] },],
};
function MatColumnDef_tsickle_Closure_declarations() {
    /** @type {?} */
    MatColumnDef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatColumnDef.ctorParameters;
    /** @type {?} */
    MatColumnDef.propDecorators;
    /**
     * Unique name for this column.
     * @type {?}
     */
    MatColumnDef.prototype.name;
}
/**
 * Header cell template container that adds the right classes and role.
 */
export class MatHeaderCell extends _MatHeaderCell {
    /**
     * @param {?} columnDef
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(columnDef, elementRef, renderer) {
        super(columnDef, elementRef, renderer);
        renderer.addClass(elementRef.nativeElement, `mat-column-${columnDef.cssClassFriendlyName}`);
    }
}
MatHeaderCell.decorators = [
    { type: Directive, args: [{
                selector: 'mat-header-cell',
                host: {
                    'class': 'mat-header-cell',
                    'role': 'columnheader',
                },
            },] },
];
/**
 * @nocollapse
 */
MatHeaderCell.ctorParameters = () => [
    { type: CdkColumnDef, },
    { type: ElementRef, },
    { type: Renderer2, },
];
function MatHeaderCell_tsickle_Closure_declarations() {
    /** @type {?} */
    MatHeaderCell.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatHeaderCell.ctorParameters;
}
/**
 * Cell template container that adds the right classes and role.
 */
export class MatCell extends _MatCell {
    /**
     * @param {?} columnDef
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(columnDef, elementRef, renderer) {
        super(columnDef, elementRef, renderer);
        renderer.addClass(elementRef.nativeElement, `mat-column-${columnDef.cssClassFriendlyName}`);
    }
}
MatCell.decorators = [
    { type: Directive, args: [{
                selector: 'mat-cell',
                host: {
                    'class': 'mat-cell',
                    'role': 'gridcell',
                },
            },] },
];
/**
 * @nocollapse
 */
MatCell.ctorParameters = () => [
    { type: CdkColumnDef, },
    { type: ElementRef, },
    { type: Renderer2, },
];
function MatCell_tsickle_Closure_declarations() {
    /** @type {?} */
    MatCell.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatCell.ctorParameters;
}
//# sourceMappingURL=cell.js.map